export const isAllowed = (value?: string) => value === "Y";

export const hasAnyPermission = (
  rbac: any,
  permissions: string[]
) => {
  return permissions.some((key) => isAllowed(rbac?.[key]));
};

export const hasAllPermissions = (
  rbac: any,
  permissions: string[]
) => {
  return permissions.every((key) => isAllowed(rbac?.[key]));
};

export const canAccessBulkPayment = (rbac: any) =>
  hasAnyPermission(rbac, [
//     "sendPaymentToLiner",
//     "createMergePayment",
    'bulkPaymentDashboard'
  ]);

export const canAccessPdfParser = (rbacDetails: any) => {
  return rbacDetails?.pdfParser === "Y";
};

export const canAccessRegisterationMst = (rbacDetails: any) => {
  return rbacDetails?.registrationMstDashboard === "Y";
};
